import { render, staticRenderFns } from "./SplitTruckOrdersTable.vue?vue&type=template&id=0f56e0a0&scoped=true"
import script from "./SplitTruckOrdersTable.vue?vue&type=script&lang=ts"
export * from "./SplitTruckOrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./SplitTruckOrdersTable.vue?vue&type=style&index=0&id=0f56e0a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f56e0a0",
  null
  
)

export default component.exports